import { renderers } from '../../drawing/renderers'

const renderCursor = (ctx, itemView) => {
  const {
    boundary,
    params: { text, cursorPosition },
  } = itemView

  let x = boundary.x + 4
  let y = boundary.y + 4
  let textLength = 0

  const lines = text.split('/n')
  let status = false
  lines.forEach((line, index) => {
    if (status) return

    if (textLength + line.length >= cursorPosition) {
      y = boundary.y + 24 * index + 4
      x =
        boundary.x +
        Math.round(ctx.measureText(line.slice(0, cursorPosition - textLength)).width + 6)
      status = true
    } else {
      textLength += line.length + 2
    }
  })
  renderers.cursor(ctx, { boundary: { x, y, width: 1.5, height: 18, angle: 0 } })
}

export const render = (itemViews, ctx) => {
  itemViews.forEach(itemView => {
    const selected = ['selected', 'dragging'].includes(itemView.type)
    const focused = itemView.type === 'focused'

    switch (itemView.entity) {
      case 'filledRectangle':
        renderers.rect(ctx, {
          boundary: itemView.boundary,
          border: itemView.params.border,
          fill: itemView.params.fill,
        })

        if (focused) {
          renderers.focusRect(ctx, {
            boundary: itemView.boundary,
          })
        }

        if (selected) {
          renderers.resizeBorder(ctx, {
            boundary: itemView.boundary,
          })

          renderers.removeButton(ctx, {
            boundary: itemView.boundary,
          })
        }
        break

      case 'backdropItem':
        renderers.invertedRect(ctx, {
          boundary: itemView.boundary,
          border: itemView.params.border,
          fill: itemView.params.fill,
        })
        break

      case 'resizeItem':
        renderers.resizeThumbs(ctx, {
          boundary: itemView.boundary,
        })
        break

      case 'line':
        renderers.line(ctx, {
          boundary: itemView.boundary,
          border: itemView.params.border,
          selected,
        })

        if (selected)
          renderers.selectionLine(ctx, {
            boundary: itemView.boundary,
            hasRemoveIcon: true,
          })
        break

      case 'arrow':
        renderers.line(ctx, {
          boundary: itemView.boundary,
          border: itemView.params.border,
          selected,
        })

        renderers.capArrow(ctx, {
          boundary: itemView.boundary,
          triangle: {
            width: 7,
            height: 20,
            fill: itemView.params.border.color,
          },
          selected,
        })

        if (selected) {
          renderers.selectionLine(ctx, {
            boundary: itemView.boundary,
            hasRemoveIcon: true,
          })
        }
        break

      case 'text': {
        renderers.rect(ctx, {
          boundary: itemView.boundary,
          border: {
            width: 0,
            color: '#000',
          },
          fill: {
            color: '#16293F',
          },
        })

        renderers.text(ctx, {
          boundary: itemView.boundary,
          text: itemView.params.text,
          fill: {
            color: '#fff',
          },
        })

        if (focused) {
          renderers.focusRect(ctx, {
            boundary: itemView.boundary,
          })
        }

        if (selected) {
          renderCursor(ctx, itemView)

          renderers.resizeBorder(ctx, {
            boundary: itemView.boundary,
          })

          renderers.removeButton(ctx, {
            boundary: itemView.boundary,
          })
        }

        break
      }
    }
  })

  itemViews.forEach(itemView => {
    const focused = itemView.type === 'focused'
    if (!focused) return

    switch (itemView.entity) {
      case 'line':
        renderers.line(ctx, {
          boundary: itemView.boundary,
          border: itemView.params.border,
          focused,
        })
        break

      case 'arrow':
        renderers.line(ctx, {
          boundary: itemView.boundary,
          border: itemView.params.border,
          focused,
        })

        renderers.capArrow(ctx, {
          boundary: itemView.boundary,
          triangle: {
            width: 7,
            height: 20,
            fill: itemView.params.border.color,
          },
          focused,
        })
        break
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/ScreenshotEditor/render.js